import { render, staticRenderFns } from "./changeBank.vue?vue&type=template&id=32bdc02e"
import script from "./changeBank.vue?vue&type=script&lang=js"
export * from "./changeBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports